// extracted by mini-css-extract-plugin
module.exports = {"root":"TeaserVideo_root_22eZW","cover":"TeaserVideo_cover_3jtEW","overlay":"TeaserVideo_overlay_1_dFb","play":"TeaserVideo_play_12KCb"};